var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 140,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.827 901.444h488.843V629.762H579.827Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.771 837.016V690.25c0-3.984 1.328-7.304 3.32-9.297l.664-.664 82.348 82.349v1.328l-83.676 82.348c-1.992-1.993-2.656-5.314-2.656-9.298"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.439 763.966v-1.993l27.228-27.227 33.205 17.93c9.297 5.313 9.297 13.946 0 19.259l-32.541 18.594-.664.665z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.427 680.289c3.321-3.32 7.969-3.32 13.946-.664l96.958 55.785-27.892 27.892z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.427 845.65 83.012-82.348 27.892 27.892-96.958 55.12c-2.692 1.496-5.115 2.183-7.269 2.183-2.627 0-4.852-1.023-6.677-2.847"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -165.26869 -165.26869 0 290.937 846.794)",
    spreadMethod: "pad",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#267caf"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4a92b4"
    },
    offset: 0.286
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#79bcba"
    },
    offset: 0.767
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#88cebc"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-49.8455 49.8455) rotate(-66.15 8.288 13.654)",
    spreadMethod: "pad",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f48879"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f5907a"
    },
    offset: 0.119
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fbb777"
    },
    offset: 0.713
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fdc874"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-116.63289 116.63289) rotate(-38.962 7.587 7.408)",
    spreadMethod: "pad",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#eb413d"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d94452"
    },
    offset: 0.167
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#af487a"
    },
    offset: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#954b92"
    },
    offset: 0.862
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#894a9c"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(109.14639 -109.14639) rotate(37.367 12.612 -.307)",
    spreadMethod: "pad",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#54c0ac"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#dde79a"
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.93333 0 0 -.93333 -141.628 629.777)",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.16359045
    },
    d: "M300.75 635.287a4.257 4.257 0 0 0-4.257-4.257H157.002a4.263 4.263 0 0 0-4.268 4.257v33.946a4.268 4.268 0 0 0 4.268 4.262h139.485a4.262 4.262 0 0 0 4.262-4.26v-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.93333 0 0 -.93333 -141.628 629.777)",
    style: {
      fill: "#a6a5a5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.16359045
    },
    d: "M296.488 630.04H157.003a5.258 5.258 0 0 0-5.258 5.247v33.945a5.26 5.26 0 0 0 5.258 5.252h139.484a5.263 5.263 0 0 0 5.257-5.252v-33.945c.002-2.894-2.36-5.247-5.256-5.247z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.93333 0 0 -.93333 -141.628 629.777)",
    style: {
      fill: "#0321bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.16359045
    },
    d: "M300.75 635.287a4.257 4.257 0 0 0-4.257-4.257H157.002a4.263 4.263 0 0 0-4.268 4.257v33.946a4.268 4.268 0 0 0 4.268 4.262h139.485a4.262 4.262 0 0 0 4.262-4.26v-.002z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.15268 0 0 -.15268 -23.169 137.895)",
    style: {
      opacity: 0.10000598
    },
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1036.532 901.444)",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-456.705l178.883-271.681H0c17.729.014 32.103 14.369 32.137 32.094v207.479C32.107-14.38 17.733-.019 0 0"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.93333 0 0 -.93333 -141.628 629.777)",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.16359045
    },
    d: "M235.384 658.007v6.518h.978l3.15-5.106v5.106h.87v-6.518h-.87l-3.367 5.323v-5.323zm-6.3 1.412c.434-.434 1.085-.76 1.737-.76.652 0 1.304.217 1.739.76a2.62 2.62 0 0 1 .76 1.847c0 .76-.217 1.413-.76 1.847-.435.435-1.087.76-1.739.76-.652 0-1.303-.217-1.738-.76a2.621 2.621 0 0 1-.76-1.847c0-.76.217-1.412.76-1.847m4.128-.543c-.651-.652-1.412-.978-2.39-.978-.977 0-1.738.326-2.39.978-.652.652-.977 1.412-.977 2.39 0 .978.325 1.738.977 2.39.652.652 1.413.978 2.39.978.978 0 1.739-.326 2.39-.978.652-.652.978-1.412.978-2.39 0-.978-.326-1.738-.978-2.39m-10.32-.869h-.87v5.758h-1.846v.76h4.454v-.76h-1.847v-5.758zm-4.563 6.518h.869v-6.518h-.87zm-4.998-6.518h-.869v5.758h-1.847v.76h4.563v-.76h-1.847zm-3.585 5.758h-2.933V661.7h2.716v-.76h-2.716v-2.065h2.933v-.869h-3.802v6.518h3.802zm-4.997-2.716c0-.87-.217-1.63-.76-2.173-.653-.652-1.413-.978-2.39-.978-.979 0-1.739.326-2.39.978-.653.652-.979 1.412-.979 2.39 0 .978.326 1.738.978 2.39.652.652 1.412.978 2.39.978.435 0 .87-.109 1.304-.326.434-.217.76-.434.978-.76l-.544-.544c-.434.544-.977.76-1.738.76-.652 0-1.303-.216-1.738-.76-.543-.434-.76-1.086-.76-1.846s.217-1.413.76-1.847c.543-.435 1.086-.76 1.738-.76.76 0 1.304.217 1.847.76a1.8 1.8 0 0 1 .543 1.303h-2.39v.87h3.15zm64.641-20.098h2.064v13.58h-2.064zm18.251 8.692-2.281-5.867h-.11l-2.39 5.867h-2.172l3.585-8.257-2.064-4.563h2.064l5.54 12.82zm-11.407-7.17c-.652 0-1.63.325-1.63 1.194 0 1.087 1.195 1.413 2.173 1.413.87 0 1.304-.218 1.847-.435-.217-1.304-1.304-2.173-2.39-2.173m.217 7.496c-1.52 0-3.042-.651-3.585-2.064l1.847-.76c.434.76 1.086.977 1.847.977 1.086 0 2.064-.651 2.173-1.738v-.108c-.326.217-1.196.543-2.065.543-1.955 0-3.91-1.087-3.91-3.042 0-1.847 1.63-3.042 3.367-3.042 1.412 0 2.064.652 2.608 1.304h.108v-1.087h1.956v5.215c-.218 2.39-2.064 3.802-4.346 3.802zm-12.493-1.955h-2.934v4.672h2.934c1.52 0 2.39-1.304 2.39-2.282-.109-1.195-.978-2.39-2.39-2.39zm-.11 6.518h-4.888v-13.58h2.064v5.106h2.825c2.281 0 4.454 1.63 4.454 4.237 0 2.608-2.173 4.237-4.454 4.237m-26.508-12.059c-1.413 0-2.608 1.195-2.608 2.825 0 1.63 1.195 2.824 2.608 2.824 1.412 0 2.499-1.195 2.499-2.824 0-1.63-1.087-2.825-2.5-2.825m2.39 6.41c-.542.543-1.412 1.086-2.498 1.086-2.281 0-4.454-2.064-4.454-4.671s2.064-4.563 4.454-4.563c1.086 0 1.956.543 2.39 1.086h.109v-.651c0-1.739-.978-2.716-2.499-2.716-1.195 0-2.064.869-2.281 1.63l-1.739-.761c.544-1.195 1.847-2.716 4.129-2.716 2.39 0 4.345 1.412 4.345 4.78v8.257h-1.955zm3.26-7.93h2.064v13.58h-2.064zm5.106 4.454c0 1.738 1.412 2.715 2.39 2.715.76 0 1.521-.434 1.738-.977zm6.301 1.52c-.434 1.087-1.52 2.934-3.91 2.934s-4.346-1.847-4.346-4.672c0-2.607 1.955-4.671 4.563-4.671 2.064 0 3.367 1.303 3.802 2.064l-1.521 1.086c-.543-.76-1.195-1.303-2.281-1.303-1.087 0-1.739.434-2.282 1.412l6.193 2.607zm-49.322 1.522v-1.956h4.671c-.108-1.086-.543-1.956-1.086-2.499-.652-.652-1.738-1.412-3.585-1.412-2.934 0-5.106 2.281-5.106 5.215 0 2.933 2.281 5.214 5.106 5.214 1.52 0 2.716-.652 3.585-1.412l1.412 1.412c-1.195 1.087-2.716 1.956-4.889 1.956-3.91 0-7.279-3.26-7.279-7.17 0-3.911 3.368-7.17 7.28-7.17 2.172 0 3.693.651 4.997 2.064 1.303 1.303 1.738 3.15 1.738 4.562 0 .435 0 .87-.109 1.196zm12.059-5.976c-1.413 0-2.608 1.195-2.608 2.825 0 1.63 1.195 2.824 2.608 2.824 1.412 0 2.607-1.086 2.607-2.824 0-1.63-1.195-2.825-2.607-2.825m0 7.388c-2.608 0-4.672-1.956-4.672-4.672a4.637 4.637 0 0 1 4.672-4.671c2.607 0 4.671 1.955 4.671 4.671 0 2.825-2.064 4.672-4.671 4.672m10.103-7.388c-1.412 0-2.607 1.195-2.607 2.825 0 1.63 1.195 2.824 2.607 2.824 1.413 0 2.608-1.086 2.608-2.824 0-1.63-1.195-2.825-2.608-2.825m0 7.388c-2.607 0-4.671-1.956-4.671-4.672a4.637 4.637 0 0 1 4.671-4.671c2.608 0 4.672 1.955 4.672 4.671 0 2.825-2.064 4.672-4.672 4.672"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(.15268 0 0 -.15268 -23.169 137.895)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#c)",
      stroke: "none"
    },
    d: "M247.771 837.016V690.25c0-3.984 1.328-7.304 3.32-9.297l.664-.664 82.348 82.349v1.328l-83.676 82.348c-1.992-1.993-2.656-5.314-2.656-9.298"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(.15268 0 0 -.15268 -23.169 137.895)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#e)",
      stroke: "none"
    },
    d: "M333.439 763.966v-1.993l27.228-27.227 33.205 17.93c9.297 5.313 9.297 13.946 0 19.259l-32.541 18.594-.664.665z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(.15268 0 0 -.15268 -23.169 137.895)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#g)",
      stroke: "none"
    },
    d: "M250.427 680.289c3.321-3.32 7.969-3.32 13.946-.664l96.958 55.785-27.892 27.892z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(.15268 0 0 -.15268 -23.169 137.895)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#i)",
      stroke: "none"
    },
    d: "m250.427 845.65 83.012-82.348 27.892 27.892-96.958 55.12c-2.692 1.496-5.115 2.183-7.269 2.183-2.627 0-4.852-1.023-6.677-2.847"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.f24791dec9af73415c8bfebea4e26dbf.svg";
export { ForwardRef as ReactComponent };